var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Credentials_1;
import { JSON, JsonDiscriminatorProperty, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var CredentialsType;
(function (CredentialsType) {
    CredentialsType["OAuth"] = "oauth";
    CredentialsType["UserPassword"] = "userPassword";
    CredentialsType["S3Credentials"] = "s3Credentials";
    CredentialsType["ApiKey"] = "apiKey";
    CredentialsType["Symon"] = "symon";
    CredentialsType["AwsRoleAssumption"] = "awsRoleAssumption";
    CredentialsType["Rest"] = "rest";
    CredentialsType["TokenBasedAuthentication"] = "tokenBasedAuthentication";
})(CredentialsType || (CredentialsType = {}));
const schema = {
    $id: 'urn:wisepipe-common:Credentials',
    type: 'object',
    properties: {
        credentialsType: {
            type: 'string',
            enum: Object.values(CredentialsType)
        }
    },
    required: ['credentialsType']
};
let Credentials = Credentials_1 = class Credentials {
    constructor(credentialsType) {
        this.credentialsType = credentialsType;
        JSON.validate(this, Credentials_1);
    }
    isOAuth2CredentialsType() {
        // Returns True for Connectors with CredentialsType.OAuth, and False for all others. The REST Connector, which is always CredentialsType.Rest, over-rides this method to return True for RestAuthCredentialsType.OAuthClientCode.
        return this.credentialsType === CredentialsType.OAuth;
    }
};
Credentials = Credentials_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorProperty('credentialsType')
], Credentials);
export { Credentials };
//# sourceMappingURL=credentials.js.map